import React, { useEffect, useState } from "react";
import { connect } from "react-redux";

import Omnisearch from "../../Common/Omnisearch";
import OmnisearchQuestions from "../../../APIRequests/omnisearch";
import { DesktopToolbar } from "./Views/DesktopToolbar";
import { admin_bp } from "../../../config/roles";
import { isAuthorized, isUserAdmin } from "../../../redux/actions/auth";
import { setOmnisearchDisplayStatus } from "../../../redux/actions/navbar";

import "./styles.scss";

function Toolbar(props) {
  const [displaySearchBar, setDisplaySearchBar] = useState(false);
  const [dynamicRouteConfig, setDynamicRouteConfig] = useState(props.dynamicRouteConfig);
  const [navbarConfiguration, setNavbarConfiguration] = useState(props.navbarConfiguration);
  const [omnisearchQuestions, setOmnisearchQuestions] = useState([]);
  const [profile, setProfile] = useState(props.profile);

  const handleClickSearch = () => {
    setDisplaySearchBar(!displaySearchBar);
    props.setOmnisearchDisplayStatus(!displaySearchBar);

    if (!displaySearchBar) {
      setTimeout(() => {
        const inputElement = document.getElementById("omnisearch-input");
        if (inputElement) {
          inputElement.focus();
        }
      }, 0);
    }
  };

  useEffect(() => {
    setNavbarConfiguration(props.navbarConfiguration);
    setProfile(props.profile);
  }, [props.navbarConfiguration, props.profile]);

  useEffect(() => {
    setDynamicRouteConfig(props.dynamicRouteConfig);
  }, [props.dynamicRouteConfig]);

  useEffect(() => {
    if (!isAuthorized(admin_bp) && isUserAdmin()) {
      OmnisearchQuestions.fetch_provider_schedule_call_list().then((omnisearchQuestionBank) => {
        setOmnisearchQuestions(omnisearchQuestionBank);
      });
    }
  }, []);

  return (
    <>
      <header className="Toolbar">
        <div>
          {
            <DesktopToolbar
              {...props}
              profile={profile}
              {...navbarConfiguration}
              handleClickSearch={handleClickSearch}
              totalUnreadMessages={props.totalUnreadMessages}
            />
          }
          {/* only visible on desktop */}
          <div className="Toolbar__margin-fix" />
        </div>
      </header>

      {displaySearchBar && (
        <div className="omnisearch-dropdown">
          <Omnisearch startFocused id="omnisearch-input" questions={omnisearchQuestions} />
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
    dynamicRouteConfig: state.dynamicRouteConfig,
  };
};

export default connect(mapStateToProps, { setOmnisearchDisplayStatus })(Toolbar);
